import { keyframes, css } from 'styled-components';


export const slideInFromRight = keyframes`
	from {
		transform: translateX(100%);
		opacity: 0;
	}

	to {
		transform: translateX(0);
		opacity: 1;
	}
`;

export const slideInUp = keyframes`
	from {
		transform: translate3d(0, 100%, 0);
		visibility: visible;
	}

	to {
		transform: translate3d(0, 0, 0);
	}
`;

export const slideOutToRight = keyframes`
	from {
		transform: translateX(0%);
		opacity: 1;
	}

	to {
		transform: translateX(100%);
		opacity: 0;
	}
`;

export const pulse = keyframes`
	0% { transform: scale(1); }
	12% { transform: scale(1.4); }
	82% { transform: scale(1); }
`;

export const heartPoof = keyframes`
	from {
		top: 0;
		opacity: 0.6;
	}

	to {
		top: -150%;
		opacity: 0;
	}
`;


export const bounce = (props) => keyframes`
	from,
	20%,
	53%,
	80%,
	to {
		animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
		transform: translate3d(0, 0, 0);
		transform-origin: center bottom
	}

	40%,
	43% {
		animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
		transform: translate3d(0, ${props.up ? '-8px' : '8px'}, 0);
	}

	70% {
		animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
		transform: translate3d(0, ${props.up ? '-4px' : '4px'}, 0);
	}

	90% {
		transform: translate3d(0, ${props.up ? '-1px' : '1px'}, 0);
	}
`;
